import { ComponentType } from '../../registries/types/propTypes';
import { CMSDataType } from '../../../utils/common';
import { ResourceOverviewProps } from '../../../components/ResourceOverview/types/propsTypes';
import { transformGalleryList } from '../promotion-overview-transformer/promotion-overview-transformer';

const transformResourceOverview = (data: CMSDataType): ResourceOverviewProps => {
  const contentDetailGallery = Array.isArray(data?.resource_overview)
    ? data?.resource_overview[0]
    : data?.resource_overview;
  return {
    componentType: ComponentType.resource_overview,
    galleryList: transformGalleryList(contentDetailGallery),
    tag: contentDetailGallery?.overview.tagline,
    title: contentDetailGallery?.overview.title,
    description: contentDetailGallery?.overview.description,
    subTitle: contentDetailGallery?.overview.sub_title,
    cta: contentDetailGallery?.overview?.cta,
  };
};

export default transformResourceOverview;
